import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

const MESSAGE_LINK_PATTERN = /(https?:\/\/[^\s]+|\/contact\b)/gi;

function renderMessageText(text) {
  const chunks = text.split(MESSAGE_LINK_PATTERN).filter(Boolean);
  let cursor = 0;

  return chunks.map((chunk) => {
    const normalizedChunk = chunk.toLowerCase();
    const position = text.indexOf(chunk, cursor);
    cursor = position + chunk.length;
    const key = `${chunk}-${position}`;

    if (normalizedChunk === '/contact') {
      return (
        <a
          key={key}
          href="/contact"
          className="inline-flex items-center rounded-md border border-cyan-400/30 bg-cyan-500/10 px-2 py-0.5 text-cyan-300 hover:bg-cyan-500/20"
        >
          Contact Us
        </a>
      );
    }

    if (/^https?:\/\//i.test(chunk)) {
      return (
        <a
          key={key}
          href={chunk}
          target="_blank"
          rel="noreferrer"
          className="text-cyan-300 underline decoration-cyan-400/40 underline-offset-2 hover:text-cyan-200"
        >
          {chunk}
        </a>
      );
    }

    return <React.Fragment key={key}>{chunk}</React.Fragment>;
  });
}

export default function ChatMessage({ message, index }) {
  const isUser = message.role === 'user';
  const text = message.parts[0].text;

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22, delay: Math.min(index * 0.04, 0.25) }}
      className={`flex ${isUser ? 'justify-end' : 'justify-start'} mb-3 items-end gap-2`}
    >
      {!isUser && (
        <div className="w-7 h-7 rounded-full bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center flex-shrink-0 shadow-[0_0_10px_rgba(59,130,246,0.28)]">
          <Sparkles className="w-3 h-3 text-white" />
        </div>
      )}
      <div
        className={`max-w-[78%] px-3.5 py-2.5 rounded-2xl text-sm leading-relaxed whitespace-pre-wrap ${
          isUser
            ? 'bg-gradient-to-br from-blue-600 to-blue-700 text-white rounded-br-sm shadow-[0_4px_16px_rgba(37,99,235,0.35)]'
            : 'bg-white/[0.05] text-gray-100 border border-white/[0.08] rounded-bl-sm'
        }`}
      >
        {renderMessageText(text)}
      </div>
    </motion.div>
  );
}
